export interface TrustedLogo {
  src: string;
  alt: string;
}

export const shopifyTrustedLogos: TrustedLogo[] = [
  { src: "/images/multi-vendor/casevilla.png", alt: "The CaseVilla" },
  { src: "/images/multi-vendor/colorbar.png", alt: "Colorbar" },
  { src: "/images/multi-vendor/health.png", alt: "Health Wellness Shop" },
  { src: "/images/multi-vendor/necked.png", alt: "Necked" },
  { src: "/images/multi-vendor/tarohi.png", alt: "Tarohi Jewels" },
  { src: "/images/multi-vendor/toyzhub.png", alt: "ToyzHub" },
  { src: "/images/multi-vendor/vastralipi_logo.png", alt: "Vastralipi" },
  { src: "/images/multi-vendor/suruchira.png", alt: "Suruchira" },
  {
    src: "/images/multi-vendor/Jewelled-by-vandana.png",
    alt: "Jewelled by Vandana",
  },
];

export interface ShopifyServiceCard {
  id: string;
  title: string;
  description: string;
  icon: string;
  alt: string;
  bgColor: string;
  darkBgColor?: string;
}

export const shopifyEndToEndServices: ShopifyServiceCard[] = [
  {
    id: "estore-customization",
    title: "eStore Customization Services",
    description:
      "Want to optimize your existing Shopify stores as per the current market trends? Hire dedicated Shopify developers for complete customization services of your eStores.",
    icon: "/images/crm/key-benefit-1.png",
    alt: "eStore Customization Services",
    bgColor: "bg-[#fcfaf7]",
    darkBgColor: "dark:bg-[#1a1c23]",
  },
  {
    id: "shopify-integration",
    title: "Shopify Integration Services",
    description:
      "Hire an expert Shopify developer to enhance the functionalities of your feature-rich Shopify Stores. From payment gateways to CRM and ERP, we can help you integrate third-party APIs seamlessly.",
    icon: "/images/shopify/service-2.svg",
    alt: "Shopify Integration Services",
    bgColor: "bg-[#f4eefc]",
    darkBgColor: "dark:bg-[#1f192b]",
  },
  {
    id: "theme-development",
    title: "Theme Development",
    description:
      "Hire qualified Shopify designers and programmers from The Dezine to craft the most intuitive and highly responsive Shopify themes for your websites and mobile applications.",
    icon: "/images/shopify/service-3.svg",
    alt: "Theme Development",
    bgColor: "bg-[#fdf2f4]",
    darkBgColor: "dark:bg-[#251920]",
  },
  {
    id: "design-and-development",
    title: "Shopify Design and Development",
    description:
      "Looking to develop perfectly crafted Shopify Stores for your business? Hire remote Shopify programmers and coders from India to design visually appealing, robust Shopify websites and applications.",
    icon: "/images/shopify/service-4.svg",
    alt: "Shopify Design and Development",
    bgColor: "bg-[#eef8ff]",
    darkBgColor: "dark:bg-[#15212d]",
  },
  {
    id: "maintenance-services",
    title: "Shopify Maintenance Services",
    description:
      "Optimizing your Shopify store is no more a problem when you hire Shopify coders from The Dezine. Our Shopify experts provide 24/7 support for smoother operations and maintenance of your stores.",
    icon: "/images/shopify/service-5.svg",
    alt: "Shopify Maintenance Services",
    bgColor: "bg-[#edf6fd]",
    darkBgColor: "dark:bg-[#16202c]",
  },
  {
    id: "migration-services",
    title: "Shopify Migration Services",
    description:
      "Want to move your existing store to Shopify? Get end-to-end support for smoother Shopify Migration of your store by hiring experienced Shopify developers from The Dezine.",
    icon: "/images/shopify/service-6.svg",
    alt: "Shopify Migration Services",
    bgColor: "bg-[#fdfbf6]",
    darkBgColor: "dark:bg-[#22211c]",
  },
];

export interface ShopifyIllustratedServiceCard {
  id: string;
  step?: string;
  title: string;
  subtitle: string;
  image: string;
  alt: string;
  points: string[];
  panelGradient?: string;
}

export const shopifyIllustratedServices: ShopifyIllustratedServiceCard[] = [
  {
    id: "theme-development",
    step: "01",
    title: "Shopify Theme Development",
    subtitle:
      "Shopify theme development for highly interactive eCommerce stores",
    image: "/images/shopify/service-1.png",
    alt: "Shopify Theme Development",
    points: [
      "Build a theme from scratch or customize off-the-shelf themes.",
      "SEO-friendly theme with cross-browser compatibility",
      "Sketch/PSD/Figma to Shopify theme with responsive designs",
    ],
  },
  {
    id: "app-development",
    step: "02",
    title: "Shopify App Development",
    subtitle: "Convert your unique ideas into feature-rich Shopify apps",
    image: "/images/shopify/service-2.png",
    alt: "Shopify App Development",
    points: [
      "Fully documented code as per Shopify Polaris standards.",
      "Reconfigure & customize your existing Shopify applications.",
      "3rd party integrations with Shopify app maintenance & support.",
    ],
  },
  {
    id: "ecommerce-store-setup",
    step: "03",
    title: "Shopify eCommerce store setup",
    subtitle:
      "Hire Shopify experts for a swift start to your eCommerce stores.",
    image: "/images/shopify/service-3.png",
    alt: "Shopify eCommerce store setup",
    points: [
      "Theme installation, app installation & multi-domain setup.",
      "Tracking setup, compatibility test, payment & shipping settings.",
      "Collection page setup, Blog setup & custom checkout pages.",
    ],
  },
  {
    id: "shopify-integration",
    step: "04",
    title: "Shopify Integration Services",
    subtitle:
      "Seamless third-party API, CRM, ERP, and payment gateway integrations.",
    image: "/images/shopify/service-4.png",
    alt: "Shopify Integration Services",
    points: [
      "Payment gateway, CRM, ERP, and shipping API integrations.",
      "Marketplace integrations with Amazon, eBay, and social channels.",
      "Real-time synchronization for inventory, orders, and customer data.",
    ],
  },
  {
    id: "migration-services",
    step: "05",
    title: "Shopify Migration Services",
    subtitle:
      "Hassle-free migration of your existing store to Shopify without data loss.",
    image: "/images/shopify/service-5.png",
    alt: "Shopify Migration Services",
    points: [
      "Migrate from WooCommerce, Magento, BigCommerce, or WordPress.",
      "Complete migration of products, customer data, and order history.",
      "Zero downtime with 301 redirects to protect SEO rankings.",
    ],
  },
  {
    id: "maintenance-services",
    step: "06",
    title: "Shopify Maintenance & Support",
    subtitle:
      "Round-the-clock technical support and optimization for your store.",
    image: "/images/shopify/service-6.png",
    alt: "Shopify Maintenance & Support",
    points: [
      "24/7 bug fixes, performance monitoring, and security updates.",
      "Speed optimization, code refactoring, and conversion improvements.",
      "Regular app audits and Shopify core version updates.",
    ],
  },
];

export interface ShopifyWorkProject {
  id: string;
  title: string;
  domain: string;
  url: string;
  image: string;
  alt: string;
  backdrop?: string;
  cardBg?: string;
  darkCardBg?: string;
}

export const shopifyWorkProjects: ShopifyWorkProject[] = [
  {
    id: "suruchira",
    title: "Suruchira",
    domain: "www.suruchira.com",
    url: "https://www.suruchira.com",
    image: "/images/shopify/suruchira.png",
    alt: "Suruchira Shopify eCommerce Store",
    cardBg: "bg-[#fceeed]",
    darkCardBg: "dark:bg-[#20181c]",
  },
  {
    id: "jewelled-by-vandana",
    title: "Jewelled by Vandana",
    domain: "www.jewelledbyvandana.com",
    url: "https://www.jewelledbyvandana.com",
    image: "/images/shopify/jewelledbyvandana.png",
    alt: "Jewelled by Vandana Shopify eCommerce Store",
    cardBg: "bg-[#f4eef9]",
    darkCardBg: "dark:bg-[#1e1724]",
  },
  {
    id: "vastralipi",
    title: "Vastralipi",
    domain: "www.vastralipi.com",
    url: "https://www.vastralipi.com",
    image: "/images/shopify/vastralipi.png",
    alt: "Vastralipi Shopify eCommerce Store",
    cardBg: "bg-[#fdf0f0]",
    darkCardBg: "dark:bg-[#221819]",
  },
  {
    id: "health-wellness",
    title: "Health Wellness",
    domain: "www.healthnwellness.shop",
    url: "https://www.healthnwellness.shop",
    image: "/images/shopify/healthnwellness.png",
    alt: "Health Wellness Shopify eCommerce Store",
    cardBg: "bg-[#eef8f5]",
    darkCardBg: "dark:bg-[#14221e]",
  },
  {
    id: "necked-jeans",
    title: "Necked Jeans",
    domain: "www.neckedjeans.com",
    url: "https://www.neckedjeans.com",
    image: "/images/shopify/necked.png",
    alt: "Necked Jeans Shopify eCommerce Store",
    cardBg: "bg-[#eef3f9]",
    darkCardBg: "dark:bg-[#161e27]",
  },
  {
    id: "tarohi-jewels",
    title: "Tarohi Jewels",
    domain: "www.tarohijewels.com",
    url: "https://www.tarohijewels.com",
    image: "/images/shopify/tarohi.png",
    alt: "Tarohi Jewels Shopify eCommerce Store",
    cardBg: "bg-[#edf8f5]",
    darkCardBg: "dark:bg-[#14221e]",
  },
  {
    id: "toyz-hub",
    title: "Toyz Hub",
    domain: "www.toyzhub.in",
    url: "https://www.toyzhub.in",
    image: "/images/shopify/toyzhub.png",
    alt: "Toyz Hub Shopify eCommerce Store",
    cardBg: "bg-[#edf8f9]",
    darkCardBg: "dark:bg-[#142125]",
  },
  {
    id: "casevilla",
    title: "Casevilla",
    domain: "www.thecasevilla.com",
    url: "https://www.thecasevilla.com",
    image: "/images/shopify/casevilla.png",
    alt: "Casevilla Shopify eCommerce Store",
    cardBg: "bg-[#eff2f7]",
    darkCardBg: "dark:bg-[#181d24]",
  },
];

export interface ShopifyClientStory {
  id: string;
  /** Reviewer's name, exactly as it appears on the review. */
  name: string;
  /** Job title, e.g. "CEO". Optional. */
  role?: string;
  /** City / country. Optional. */
  location?: string;
  /** Photo. Optional — an initial badge renders when absent. */
  avatar?: string;
  /**
   * Client's brand mark. Only set this when the reviewer actually belongs
   * to that brand — pairing a real person with an unrelated logo
   * misrepresents them. Leave it out otherwise.
   */
  brandLogo?: string;
  brandAlt?: string;
  /** Review text, verbatim as written by the reviewer. */
  review: string;
  /** Star rating, 1–5. */
  rating: number;
}

export const shopifyClientStories: ShopifyClientStory[] = [
  // Verified client reviews from GoodFirms (5.0 overall, 6 reviews):
  // https://www.goodfirms.co/company/the-dezine
  // Each `review` is a verbatim excerpt from the opening of that review.
  {
    id: "hardik-thakar",
    name: "Hardik Thakar",
    role: "CEO at B2B Business Network Platform",
    review:
      "The Dezine delivered a professional website for the Indo-Canadian Alliance Business Tour 2026 that exceeded our expectations. Their team communicated clearly throughout the project, understood our vision for connecting entrepreneurs and investors across Canada, and executed the web design, development, and digital marketing work with precision.",
    rating: 5,
  },
  {
    id: "mihir-joshi",
    name: "Mihir Joshi",
    role: "Director at Alpha Hospital",
    review:
      "Our overall experience with The Dezine Company has been exceptional. From the beginning, they demonstrated a deep understanding of our business needs and provided tailored solutions to strengthen our digital presence.",
    rating: 5,
  },
  {
    id: "suruchira",
    name: "Suruchira Management",
    role: "Founder at Suruchira",
    review:
      "Working with The Dezine.in for the development of Suruchira.com was an outstanding experience from start to finish. Their team demonstrated a deep understanding of my brand vision for Suruchira, a women\u2019s fashion store, and worked closely with me to ensure every detail was perfect.",
    rating: 5,
  },
  {
    id: "eway-mart",
    name: "Earn2Click",
    role: "Founder at eWay Mart",
    review:
      "We\u2019ve been working with The Dezine IT Company for over 4 years now, and it\u2019s been an incredible journey. They initially developed our eCommerce portal for EwayMart, focused on grocery products.",
    rating: 5,
  },
  {
    id: "abhishek-sharma",
    name: "Abhishek Sharma",
    role: "Owner / CEO at GroDoor Supermarket",
    review:
      "I had the privilege of collaborating with The Dezine on the development of my eCommerce app, Grodoor, and the experience was remarkable. Their team demonstrated excellent technical skills, clear communication, and a solid understanding of eCommerce development.",
    rating: 5,
  },
  {
    id: "henul-raj",
    name: "Henul Raj",
    role: "CEO at EVOQ Infotech",
    review:
      "Our experience with The Dezine has been outstanding. From the initial consultation to the final delivery of EVOQ, our salon and spa management software, they demonstrated exceptional expertise, professionalism, and commitment.",
    rating: 5,
  },
];

export interface ShopifyHiringModel {
  id: string;
  title: string;
  description: string;
  icon: string;
  alt: string;
  bg: string;
  border: string;
  darkBg?: string;
  darkBorder?: string;
}

export const shopifyHiringModels: ShopifyHiringModel[] = [
  {
    id: "dedicated-expert",
    title: "Dedicated Shopify Expert",
    description:
      "Full-time Shopify developer One-to-one Reporting Work as per client needs",
    icon: "/images/shopify/expert-1.png",
    alt: "Dedicated Shopify Expert",
    bg: "bg-[#f0f4fe]",
    border: "border-b-[#8ea2fe]",
    darkBg: "dark:bg-slate-900",
    darkBorder: "dark:border-b-indigo-700",
  },
  {
    id: "fixed-price",
    title: "Fixed Price Model",
    description:
      "One-time fixed-price contract Fixed deadlines & budgets Milestone-based payment",
    icon: "/images/shopify/expert-2.png",
    alt: "Fixed Price Model",
    bg: "bg-[#fdf0f9]",
    border: "border-b-[#f195e0]",
    darkBg: "dark:bg-slate-900",
    darkBorder: "dark:border-b-pink-700",
  },
  {
    id: "hourly",
    title: "Hourly",
    description:
      "Hour-wise rolling contract Pay only for measurable work Weekly or Monthly billing",
    icon: "/images/shopify/expert-3.png",
    alt: "Hourly Hiring Model",
    bg: "bg-[#eefcfc]",
    border: "border-b-[#63e3e3]",
    darkBg: "dark:bg-slate-900",
    darkBorder: "dark:border-b-cyan-700",
  },
];

export interface ShopifyAdvantage {
  id: string;
  title: string;
  description: string;
  icon: string;
  alt: string;
}

export const shopifyAdvantages: ShopifyAdvantage[] = [
  {
    id: "build-your-own-team",
    title: "Build your own Team",
    description:
      "Choose and hire dedicated Shopify developers of your choice by screening and interviewing.",
    icon: "/images/shopify/adv-1.svg",
    alt: "Build your own Team",
  },
  {
    id: "effortless-smooth",
    title: "Effortless & smooth",
    description:
      "Hiring remote Shopify programmers at The Dezine is effortless and hassle-free with our simple 5-step hiring process.",
    icon: "/images/shopify/adv-2.svg",
    alt: "Effortless & smooth",
  },
  {
    id: "access-to-resources",
    title: "Access to a Pool of Resources",
    description:
      "We have an array of highly proficient Shopify coders, programmers, engineers globally to help you choose from the best.",
    icon: "/images/shopify/adv-3.svg",
    alt: "Access to a Pool of Resources",
  },
  {
    id: "save-costs",
    title: "Save Costs",
    description:
      "Hire dedicated Shopify developers from The Dezine at the most affordable hiring costs and save huge expenses on in-house hiring.",
    icon: "/images/shopify/expert-2.png",
    alt: "Save Costs",
  },
  {
    id: "better-communication",
    title: "Better Communication",
    description:
      "The dedicated project manager keeps owners updated about every development stage with regular reports.",
    icon: "/images/shopify/adv-5.svg",
    alt: "Better Communication",
  },
  {
    id: "deep-domain-expertise",
    title: "Deep Domain Expertise",
    description:
      "The qualified Shopify programmers and coders hold in-depth knowledge and expertise in Shopify technologies.",
    icon: "/images/shopify/adv-6.svg",
    alt: "Deep Domain Expertise",
  },
];

export interface ShopifyTechnologyBadge {
  id: string;
  label: string;
  bgColor: string;
  textColor: string;
  darkBgColor?: string;
  darkTextColor?: string;
}

export const shopifyTechnologyBadges: ShopifyTechnologyBadge[] = [
  {
    id: "multiple-payment-gateways",
    label: "Multiple Payment Gateways",
    bgColor: "bg-[#dff3ea]",
    textColor: "text-[#1c734e]",
    darkBgColor: "dark:bg-[#142920]",
    darkTextColor: "dark:text-[#58d49f]",
  },
  {
    id: "seo-optimized",
    label: "SEO-Optimized",
    bgColor: "bg-[#9d60d3]",
    textColor: "text-white",
    darkBgColor: "dark:bg-[#7b3caa]",
    darkTextColor: "dark:text-white",
  },
  {
    id: "seo-friendly",
    label: "SEO-friendly",
    bgColor: "bg-[#e2f1e6]",
    textColor: "text-[#2e7442]",
    darkBgColor: "dark:bg-[#182a1d]",
    darkTextColor: "dark:text-[#64d084]",
  },
  {
    id: "built-in-marketing-tools",
    label: "Built-in Marketing Tools",
    bgColor: "bg-[#fde5d5]",
    textColor: "text-[#b65324]",
    darkBgColor: "dark:bg-[#2d1e16]",
    darkTextColor: "dark:text-[#f89b6c]",
  },
  {
    id: "pos-integrations",
    label: "POS Integrations",
    bgColor: "bg-[#a662dc]",
    textColor: "text-white",
    darkBgColor: "dark:bg-[#8643bd]",
    darkTextColor: "dark:text-white",
  },
  {
    id: "easy-management",
    label: "Easy Management",
    bgColor: "bg-[#d4d6fc]",
    textColor: "text-[#3e48ab]",
    darkBgColor: "dark:bg-[#1b1e36]",
    darkTextColor: "dark:text-[#8894fa]",
  },
  {
    id: "tons-of-themes",
    label: "Tons of Themes",
    bgColor: "bg-[#d5f3ea]",
    textColor: "text-[#1e6f51]",
    darkBgColor: "dark:bg-[#142822]",
    darkTextColor: "dark:text-[#52d2a4]",
  },
  {
    id: "powerful-analytics",
    label: "Powerful Analytics",
    bgColor: "bg-[#fddcd0]",
    textColor: "text-[#b84824]",
    darkBgColor: "dark:bg-[#2d1b15]",
    darkTextColor: "dark:text-[#f79471]",
  },
  {
    id: "seamless-integrations",
    label: "Seamless Integrations",
    bgColor: "bg-[#d8eedd]",
    textColor: "text-[#29673a]",
    darkBgColor: "dark:bg-[#16271c]",
    darkTextColor: "dark:text-[#63cd82]",
  },
];

export interface ShopifyDeveloperLevel {
  title: string;
  experience: string;
  projectsManaged: string;
  hoursCompleted: string;
}

export const shopifyDeveloperLevels: ShopifyDeveloperLevel[] = [
  {
    title: "Junior Shopify Developer",
    experience: "1-3",
    projectsManaged: "4-8",
    hoursCompleted: "1500",
  },
  {
    title: "Senior Shopify Developer",
    experience: "3-6",
    projectsManaged: "8-20",
    hoursCompleted: "5000+",
  },
  {
    title: "Full Stack Shopify Developer",
    experience: "2-6",
    projectsManaged: "5-20",
    hoursCompleted: "7000+",
  },
];

export const shopifyTechnicalSkills: string[] = [
  "In-depth understanding of Shopify's Admin System.",
  'Strong programming knowledge of Shopify "Liquid" and Themes.',
  "Knowledge of JavaScript, HTML5 and CSS3.",
  "Knowledge of PHP, Ruby on Rails, and other scripting languages.",
  "Knowledge of JSON REST API with Auth.",
  "knowledge of popular eCommerce Platforms like Magento, WooCommerce, and BigCommerce.",
];

export const shopifyNonTechnicalSkills: string[] = [
  "Problem-solving skills and ability to handle stress.",
  "Great communication skills and interacts with the team well.",
  "A desire for learning, growth, and taking on new challenges.",
  "Good at communicating with clients and responding to queries.",
  "Stay updated with the latest advances in Laravel.",
  "Manage time and follow strict deadlines.",
];

export interface ShopifyIndustry {
  id: string;
  title: string;
  description: string;
  icon: string;
  alt: string;
  bg: string;
  darkBg?: string;
  features: string[];
}

export const shopifyIndustries: ShopifyIndustry[] = [
  {
    id: "education",
    title: "Education",
    description:
      "With a team of expert Education app developers, we build innovative education app solutions. We make e-learning fun by adding gamification to the education app development services.",
    icon: "/images/flutter/industry-2.svg",
    alt: "Education Industry",
    bg: "bg-[#e8e4ff]",
    darkBg: "dark:bg-[#1a172e]",
    features: [
      "E-learning Portals",
      "Educational Gaming App",
      "School Management",
      "Online Tutor App",
    ],
  },
  {
    id: "on-demand",
    title: "On-Demand",
    description:
      "We excel in developing custom on-demand solutions enabling business owners to serve their customers when needed. Our On-demand developers have been developing on-demand apps for over a decade.",
    icon: "/images/flutter/industry-3.svg",
    alt: "On-Demand Industry",
    bg: "bg-[#faeedd]",
    darkBg: "dark:bg-[#2a241b]",
    features: [
      "Food Delivery App",
      "Liquor Delivery App",
      "Pharmacy Delivery",
      "Cannabis Delivery App",
    ],
  },
  {
    id: "automotive",
    title: "Automotive",
    description:
      "At The Dezine, we focus on increasing the business efficiency of our clients. Thus, we develop and deliver next-gen automotive IT solutions to help improve connectivity and cost-efficiency.",
    icon: "/images/flutter/industry-1.svg",
    alt: "Automotive Industry",
    bg: "bg-[#faeedd]",
    darkBg: "dark:bg-[#2a241b]",
    features: [
      "Vehicle Maintenance App",
      "GPS Solutions",
      "CRM Solutions",
      "POS Solutions",
    ],
  },
];

export interface ShopifyHiringStep {
  id: string;
  step: number;
  title: string;
  description: string;
  icon: string;
  alt: string;
}

export const shopifyHiringSteps: ShopifyHiringStep[] = [
  {
    id: "step-1",
    step: 1,
    title: "Tell us your Shopify Development Needs",
    description:
      "Send us your inquiries, and we will select the most qualified talent for you.",
    icon: "/images/shopify/h-icon-1.svg",
    alt: "Tell us your Shopify Development Needs",
  },
  {
    id: "step-2",
    step: 2,
    title: "Check Resumes and Start Screening",
    description:
      "We share the CVs of top-rated Shopify engineers for you to screen and assess.",
    icon: "/images/shopify/h-icon-2.svg",
    alt: "Check Resumes and Start Screening",
  },
  {
    id: "step-3",
    step: 3,
    title: "Interview Handpicked Developers",
    description:
      "Select the best few for the interview and test their skills and capabilities.",
    icon: "/images/shopify/h-icon-3.svg",
    alt: "Interview Handpicked Developers",
  },
  {
    id: "step-4",
    step: 4,
    title: "Sign an NDA & Start Onboarding",
    description:
      "Once satisfied with the interview, hire Shopify developers after signing.",
    icon: "/images/shopify/h-icon-4.svg",
    alt: "Sign an NDA & Start Onboarding",
  },
  {
    id: "step-5",
    step: 5,
    title: "Initiate the Project & Assign Tasks",
    description:
      "Start building your Shopify projects after assigning tasks to Shopify coders.",
    icon: "/images/shopify/h-icon-5.svg",
    alt: "Initiate the Project & Assign Tasks",
  },
];

export interface ShopifyCtaBanner {
  id: string;
  title: string;
  buttonText: string;
  buttonHref: string;
  bgGradient: string;
  shadowColor: string;
}

export const shopifyCtaBanners: ShopifyCtaBanner[] = [
  {
    id: "cta-experts",
    title:
      "Would You like Hiring Shopify Experts to Develop Your Shopify Stores?",
    buttonText: "Hire Shopify Expert Today",
    buttonHref: "/contact",
    bgGradient: "bg-gradient-to-r from-[#ffa77f] via-[#ff548b] to-[#ff2182]",
    shadowColor: "shadow-[0_12px_36px_rgba(255,42,133,0.22)]",
  },
  {
    id: "cta-assistance",
    title: "Want the Expert Assistance of Shopify Developers?",
    buttonText: "Hire Shopify Expert Today",
    buttonHref: "/contact",
    bgGradient: "bg-gradient-to-r from-[#592cb6] via-[#4d3ecc] to-[#2482f6]",
    shadowColor: "shadow-[0_12px_36px_rgba(36,130,246,0.22)]",
  },
];

export interface ShopifyOtherService {
  id: string;
  title: string;
  description: string;
  icon: string;
  alt: string;
  linkText: string;
  linkHref: string;
}

export const shopifyOtherServices: ShopifyOtherService[] = [
  {
    id: "aws-developers",
    title: "Hire AWS Developers",
    description:
      "The Dezine can make your cloud development journey easier. Hire dedicated AWS Developers for the perfect AWS cloud solutions.",
    icon: "/images/multi-vendor/images/logo/aws.png",
    alt: "Hire AWS Developers",
    linkText: "View More",
    linkHref: "/contact",
  },
  {
    id: "vuejs-developers",
    title: "Hire VueJS Developers",
    description:
      "Aim to build lightweight single-page applications? Rely on the expertise of remote offshore VueJS developers at The Dezine.",
    icon: "/images/multi-vendor/images/logo/vue.png",
    alt: "Hire VueJS Developers",
    linkText: "View More",
    linkHref: "/contact",
  },
  {
    id: "reactjs-developers",
    title: "Hire ReactJS Developer",
    description:
      "Build high-performance, dynamic user interfaces and scalable web applications with experienced ReactJS developers at The Dezine.",
    icon: "/images/multi-vendor/images/logo/react.png",
    alt: "Hire ReactJS Developer",
    linkText: "View More",
    linkHref: "/contact",
  },
];

export interface ShopifyFeatureServiceCard {
  id: string;
  title: string;
  subtitle: string;
  image: string;
  alt: string;
  points: string[];
  topGradient?: string;
}

export const shopifyFeatureServices: ShopifyFeatureServiceCard[] = [
  {
    id: "theme-development",
    title: "Shopify Theme Development",
    subtitle:
      "Shopify theme development for highly interactive eCommerce stores",
    image: "/images/shopify/service-1.png",
    alt: "Shopify Theme Development",
    points: [
      "Build a theme from scratch or customize off-the-shelf themes.",
      "SEO-friendly theme with cross-browser compatibility",
      "Sketch/PSD/Figma to Shopify theme with responsive designs",
    ],
  },
  {
    id: "app-development",
    title: "Shopify App Development",
    subtitle: "Convert your unique ideas into feature-rich Shopify apps",
    image: "/images/shopify/service-2.png",
    alt: "Shopify App Development",
    points: [
      "Fully documented code as per Shopify Polaris standards.",
      "Reconfigure & customize your existing Shopify applications.",
      "3rd party integrations with Shopify app maintenance & support.",
    ],
  },
  {
    id: "ecommerce-store-setup",
    title: "Shopify eCommerce store setup",
    subtitle:
      "Hire Shopify experts for a swift start to your eCommerce stores.",
    image: "/images/shopify/service-3.png",
    alt: "Shopify eCommerce store setup",
    points: [
      "Theme installation, app installation & multi-domain setup.",
      "Tracking setup, compatibility test, payment & shipping settings.",
      "Collection page setup, Blog setup & custom checkout pages.",
    ],
  },
];
